export {DeleteAccountLayout} from './DeleteAccountLayout';
